import Vue from "vue"
import moment from "moment"

Vue.filter("formatTime", (value) => {
  return moment(value).format("YYYY/MM/DD")
})

// 空数据转换
Vue.filter("formatValue", (value) => {
  return value || `--`
})

// 处理文件大小
Vue.filter("fontSizeFilter", function (value) {
  if (!value) {
    return "--"
  }
  if (value < 1024) {
    return value + "B"
  }
  if (value < 1024 * 1024) {
    return (value / 1024).toFixed(2) + "KB"
  }
  if (value < 1024 * 1024 * 1024) {
    return (value / 1024 / 1024).toFixed(2) + "MB"
  }
  if (value < 1024 * 1024 * 1024 * 1024) {
    return (value / 1024 / 1024 / 1024).toFixed(2) + "GB"
  }
  return "--"
})


// 文字超出指定长度某位显示省略号
Vue.filter('textHiddenTail', function (value, length) {
  let str = value && value.toString()
  if (str && str.length > length) {
    return str.substring(0, length) + '...'
  } else {
    return str
  }
})